export default __webpack_public_path__ + "static/media/bgBarGraph.d1f6e160.svg";